module.exports = __webpack_public_path__ + "static/img_3418-78c46408bef736a8f315992d3e563f01.jpg";